(function($) {
  'use strict';
  const contentSwitcher = $('#content-switcher');
  const switcherLinks = $(contentSwitcher.find('a'));
  const openOffers = window.location.search.includes('tab=offers');
  contentSwitcher.find(`.${contentSwitcher.find('.switcher').attr('data-default-tab')}`).addClass('active');
  $('.animated-link').wrap('<div class="js-link"></div>').prepend('<div class="signet"></div>').append('<div class="signet-spacer"></div>');

  switcherLinks.on('click', function(event) {
    event.preventDefault();
    const clickedTab = $(this);
    if (clickedTab.hasClass('active')) {
      return null;
    }
    let url;
    if (clickedTab.hasClass('classes')) {
      // Honor the href twig rendered (carries tab=offers and the
      // node's structure filter) so the React app's StructurePreFilter
      // sees the filter on first load.
      const targetHref = clickedTab.attr('href');
      url = (targetHref && targetHref !== '#')
        ? new URL(targetHref, window.location.href)
        : new URL(window.location);
      url.searchParams.set('tab', 'offers');
    } else {
      url = new URL(window.location);
      url.searchParams.delete('tab');
      url.searchParams.delete('filter');
    }
    window.history.pushState({}, '', url);
    switcherLinks.removeClass('active');
    clickedTab.addClass('active');

    $('.node-tab-content').toggleClass('active');
  });

  if (openOffers) {
    contentSwitcher.find('a.classes').click();
  }

  $('#front-page-search .start-search').on('click', function(e) {
    e.preventDefault();
    const searchString = $('#search-string').val();
    const searchLocation = $('#search-location').val();

    // Absoluter Pfad ab Domainwurzel. Frueher wurde 'suche?...' an
    // window.location.href gehaengt - das ging nur auf / gut, mit einem
    // Query-String entstand /?foo=1suche?tab=offers, und jeder weitere
    // Klick hing erneut an. URLSearchParams kodiert ausserdem Suchbegriffe
    // mit Sonderzeichen korrekt.
    const params = new URLSearchParams({ tab: 'offers' });
    if (searchString.length > 0) {
      params.set('search', searchString);
    }
    if (searchLocation > 0 && searchLocation !== 'All') {
      params.set('location', searchLocation);
    }
    if ($(this).hasClass('advanced-search')) {
      params.set('advanced', 'true');
    }

    window.location.replace('/suche?' + params.toString());
  });

  $(document).ready(() => {
    // Open ALL external links in new tab/window.
    $('a').filter(function() {
      return this.hostname && this.hostname !== location.hostname;
    }).addClass('external-link').attr('target', '_blank');
  });

  window.addEventListener('popstate', function (event) {
    if ($('#content-switcher').length > 0) {
      const url = new URL(window.location);
      const tabActive = url.searchParams.get('tab')?.length > 0;
      const classListTab = $('#offer-search.node-tab-content');
      const otherTab = $('.node-tab-content:not(#offer-search)');
      if (tabActive) {
        $('#detail-tab').removeClass('active');
        otherTab.removeClass('active');
        $('#list-tab').addClass('active');
        classListTab.addClass('active');
      } else {
        $('#list-tab').removeClass('active');
        classListTab.removeClass('active');
        $('#detail-tab').addClass('active');
        otherTab.addClass('active');
      }
    }
  });

})(jQuery);
